import React from "react";

export default function Terms() {
  return (
    <section style={{ maxWidth: 760 }}>
      <h2 className="section-title">Пользовательское соглашение</h2>

      <div style={{
        background: "#fff1f6", border: "1.5px solid #e5005b", borderRadius: 10,
        padding: "12px 16px", marginBottom: 20, fontSize: "0.9rem", color: "#9c0040",
      }}>
        ⚠️ Черновик документа, требующий заполнения реквизитов и юридической проверки
        перед публикацией. Раздел 3 согласован с Политикой конфиденциальности (раздел 6.1) —
        оба должны обновляться синхронно.
      </div>

      <div className="article-body">
        <p>Действует с [ЗАПОЛНИТЬ: дата вступления в силу].</p>

        <h3>1. Общие положения</h3>
        <p>
          Настоящее Пользовательское соглашение (далее — «Соглашение») регулирует отношения
          между [ЗАПОЛНИТЬ: ФИО/наименование и организационно-правовая форма], ИНН
          [ЗАПОЛНИТЬ: ИНН] (далее — «Администрация») и пользователями научно-образовательного
          портала «Современный Врач» (svrach.ru, далее — «Портал»).
        </p>
        <p>
          Регистрируясь на Портале, пользователь подтверждает, что ознакомился и согласен
          с условиями настоящего Соглашения и Политикой обработки персональных данных.
        </p>

        <h3>2. Назначение Портала</h3>
        <p>Портал предназначен для медицинских специалистов и предоставляет:</p>
        <ul>
          <li>публикацию научно-образовательных материалов (статьи, видео-лекции) и обмен
            клиническим опытом (раздел «Клинические случаи»);</li>
          <li>профессиональное общение — форум с каналами по специальностям, чат в реальном
            времени, справочник коллег;</li>
          <li>доступ к базе клинических рекомендаций Минздрава России и Государственному
            реестру лекарственных средств (ГРЛС) с полнотекстовым и ИИ-поиском по этим
            и собственным материалам Портала;</li>
          <li>клинические калькуляторы и шкалы риска, а также инструмент анонимизации PDF;</li>
          <li>получение и предоставление второго мнения по диагностическим записям
            (ЭКГ, Холтер, СМАД) — письменного заключения или очной онлайн-консультации;</li>
          <li>ведение публичного профиля врача с показателями активности и цитируемости.</li>
        </ul>

        <h3 style={{ color: "#c0392b" }}>3. Медицинский дисклеймер</h3>
        <p>
          <strong>Материалы Портала, включая ответы ИИ-поиска и еженедельный дайджест, носят
          информационно-образовательный характер и не являются медицинской консультацией,
          диагнозом или назначением лечения.</strong> Ответы ИИ-поиска формируются на основе
          материалов Портала и текста клинических рекомендаций, но могут содержать неточности;
          финальное решение всегда принимает врач самостоятельно. Администрация не несёт
          ответственности за клинические решения, принятые на основе материалов Портала.
          Все решения о диагностике и лечении конкретного пациента принимаются врачом
          самостоятельно, с учётом действующих клинических рекомендаций и индивидуальных
          особенностей пациента.
        </p>
        <p>
          Раздел «Клинические случаи» предназначен для профессионального обсуждения.
          Пользователи обязаны деперсонализировать (анонимизировать) любые данные пациентов
          перед публикацией — удалять ФИО, даты рождения, номера медицинских документов
          и иные идентифицирующие сведения. Для деперсонализации файлов рекомендуется
          использовать раздел «Инструменты» Портала.
        </p>
        <p style={{ background: "#fef2f2", border: "1px solid #fecaca", borderRadius: 8, padding: "10px 14px" }}>
          <strong>Второе мнение.</strong> Загружая запись ЭКГ, Холтеровского мониторирования
          или СМАД для получения второго мнения, пользователь подтверждает, что: (а) обладает
          законным основанием передать данные пациента, содержащиеся в записи, третьему лицу —
          эксперту-рецензенту Портала, либо (б) запись деперсонализирована перед загрузкой.
          Ответственность за законность передачи данных пациента, содержащихся в загруженной
          записи, несёт загрузивший её пользователь. [ЗАПОЛНИТЬ ПОСЛЕ КОНСУЛЬТАЦИИ С ЮРИСТОМ:
          см. связанный пункт 6.1 Политики конфиденциальности — вопрос требует юридического
          решения до включения раздела в продакшн.]
        </p>

        <h3>4. Регистрация и аккаунт</h3>
        <ul>
          <li>Регистрация доступна лицам, ознакомившимся с настоящим Соглашением и
            предоставившим согласие на обработку персональных данных;</li>
          <li>пользователь обязуется предоставлять достоверные данные при регистрации;</li>
          <li>ряд функций (публикация материалов, отправка записей на второе мнение,
            обращение к эксперту-рецензенту) доступен только пользователям со статусом
            «Подтверждённый врач», присваиваемым после проверки Администрацией загруженного
            диплома или сертификата;</li>
          <li>пользователь несёт ответственность за сохранность данных для входа в свой
            аккаунт;</li>
          <li>пользователь вправе удалить свой аккаунт в любой момент через раздел «Профиль».</li>
        </ul>

        <h3>5. Правила использования</h3>
        <p>Публикуя материалы, комментарии, отзывы или сообщения в чате, пользователь обязуется не:</p>
        <ul>
          <li>размещать персональные данные третьих лиц (включая пациентов) без анонимизации
            или законного основания на их передачу — см. раздел 3;</li>
          <li>размещать материалы, нарушающие законодательство РФ, авторские права третьих лиц;</li>
          <li>заниматься рекламой и спамом без согласования с Администрацией;</li>
          <li>нарушать нормы профессиональной этики при общении с коллегами.</li>
        </ul>
        <p>
          Администрация вправе удалять материалы, нарушающие настоящие правила, и
          ограничивать доступ пользователей-нарушителей без предварительного уведомления.
        </p>

        <h3>6. Интеллектуальная собственность</h3>
        <p>
          Публикуя материал на Портале, пользователь сохраняет авторские права на него и
          предоставляет Администрации неисключительную лицензию на его размещение,
          отображение и распространение в рамках функционала Портала (включая публикацию
          ссылки и анонса материала в социальных сетях и мессенджерах, а также использование
          текста материала для формирования ответов ИИ-поиска и еженедельного дайджеста
          в рамках самого Портала).
        </p>

        <h3>7. Ограничение ответственности</h3>
        <p>
          Портал предоставляется «как есть». Администрация не гарантирует бесперебойную
          работу Портала и не несёт ответственности за временную недоступность сервиса,
          за содержание материалов, публикуемых пользователями, а также за содержание
          заключений, предоставленных экспертами-рецензентами в разделе «Второе мнение»,
          — эти заключения являются мнением конкретного специалиста, а не позицией Портала.
        </p>

        <h3>8. Изменение условий</h3>
        <p>
          Администрация вправе изменять условия настоящего Соглашения. Актуальная редакция
          всегда доступна по адресу /terms.
        </p>

        <h3>9. Контакты</h3>
        <p>
          По вопросам, связанным с настоящим Соглашением, обращайтесь:
          [ЗАПОЛНИТЬ: контактный email].
        </p>
      </div>
    </section>
  );
}
